import React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { Tooltip } from 'antd';
import DeleteModal from '../../components/common/delete_modal';
import ConfirmationModal from '../../components/common/confirmationModal';

export function CommandCell({ rowbuttonAction, actionbuttons, deleteFunc }) {
  return class extends GridCell {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
      super(props);
      this.state = {};
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
      const { dataItem } = this.props;
      if (dataItem && !dataItem.field) {
        return (
          <td className="k-command-cell">
            <div className="action">
              {
                                actionbuttons.Add
                                && (
                                <Tooltip title="Adicionar" color="#808080">
                                  <span onClick={() => rowbuttonAction('Add', dataItem)}><i className="fas fa-plus-circle text-active" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.Edit
                                && (
                                <Tooltip title="Consultar registo" color="#808080">
                                  <span onClick={() => rowbuttonAction('Edit', dataItem)}><span className="k-icon k-i-hyperlink-open-sm" /></span>
                                </Tooltip>
                                )
                            }

              {
                                actionbuttons.GroupEdit
                                && (
                                <Tooltip title="Editar registo" color="#808080">
                                  <span data-toggle="modal" data-target="#new-group" onClick={() => rowbuttonAction('GroupEdit', dataItem)}><span className="k-icon k-i-hyperlink-open-sm mr-2" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.Redirect
                                && (
                                <Tooltip title={actionbuttons.Redirect} color="#808080">
                                  <span onClick={() => rowbuttonAction('Redirect', dataItem)}><i className="fas fa-caret-square-left  ml-2 mr-3 text-yellow" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.RedirectTwo
                                && (
                                <Tooltip title={actionbuttons.RedirectTwo} color="#808080">
                                  <span onClick={() => rowbuttonAction('RedirectTwo', dataItem)}><span className="k-icon k-i-redo" /></span>
                                </Tooltip>
                                )
                            }

              {
                                actionbuttons.PermissionRedirect
                                && (
                                <Tooltip title={actionbuttons.PermissionRedirect} color="#808080">
                                  <span onClick={() => rowbuttonAction('Redirect', dataItem)}><i className="fas fa-caret-square-left  ml-2 mr-3 text-yellow" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.detailPopUp
                                && (
                                <Tooltip title="Detalhe" color="#808080">
                                  <span data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('detailPopUp', dataItem)}><span className="k-icon k-i-information" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.detailPopUpTwo
                                && (
                                <Tooltip title="Detalhe" color="#808080">
                                  <span data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('detailPopUpTwo', dataItem)}><span className="k-icon k-i-hyperlink-open-sm" /></span>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.Popup
                                && (
                                <Tooltip title="Detalhe" color="#808080">
                                  <span data-toggle="modal" data-target="#left-popup-center" onClick={() => rowbuttonAction('detailsPopup', dataItem)}><span className="k-icon k-i-information" /></span>
                                </Tooltip>
                                )

                            }
              {
                                actionbuttons.LegalPopup
                                && (
                                <Tooltip title="Detalhe" color="#808080">
                                  <span data-toggle="modal" data-target="#left-popup-center" onClick={() => rowbuttonAction('legalPopup', dataItem)}><span className="k-icon k-i-information" /></span>
                                </Tooltip>
                                )

                            }
              {
                                actionbuttons.Dropdown
                                && (
                                <Tooltip title="Mais opções" color="#808080">
                                  <i className="fa fa-ellipsis-v" aria-hidden="true" data-toggle="dropdown" />
                                  <div className="dropdown-menu">
                                    <span className="dropdown-item mt-2 mr-5 " onClick={() => rowbuttonAction('Map', dataItem)}>
                                      Ver no mapa
                                      <i className="fas fa-map-marker float-right" aria-hidden="true" />
                                    </span>
                                    <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('History', dataItem)}>
                                      Histórico
                                      <i className="fa fa-history float-right" aria-hidden="true" />
                                    </span>
                                    <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('Print', dataItem)}>
                                      Imprimir
                                      <i className="fas fa-print float-right" />
                                    </span>
                                    <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('remind', dataItem)}>
                                      Rendimento
                                      <i className="fas fa-water float-right" />
                                    </span>

                                  </div>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.DropdownRevenue
                                && (
                                <Tooltip title="Mais opções" color="#808080">
                                  <i className="fa fa-ellipsis-v" aria-hidden="true" data-toggle="dropdown" />
                                  <div className="dropdown-menu">
                                    <span className="dropdown-item mt-2 mr-5 " data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Alterar prazo de pagamento', dataItem)}>
                                      Alterar prazo de pagamento
                                      <i className="fas fa-map-marker float-right" aria-hidden="true" />
                                    </span>
                                    <span className="dropdown-item mt-2" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Sinalizar', dataItem)}>
                                      Sinalizar
                                      <i className="fa fa-history float-right" aria-hidden="true" />
                                    </span>
                                    <span className="dropdown-item mt-2" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Processar fatura', dataItem)}>
                                      Processar fatura
                                      <i className="fas fa-print float-right" />
                                    </span>
                                    <span className="dropdown-item mt-2" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Anular fatura', dataItem)}>
                                      Anular fatura
                                      <i className="fas fa-water float-right" />
                                    </span>

                                  </div>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.DropdownVinRegisto
                                && (
                                <Tooltip title="Mais opções" color="#808080">
                                  <i className="fa fa-ellipsis-v" aria-hidden="true" data-toggle="dropdown" />
                                  <div className="dropdown-menu">
                                    <span className="dropdown-item mt-2 mr-5 " data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Preencher/Validar nº IVV', dataItem)}>
                                      Preencher/Validar nº IVV
                                      <i className="fas fa-map-marker float-right" aria-hidden="true" />
                                    </span>
                                    <div className="multilevel-menu">
                                      <div className="dropdown">
                                        <span className="dropdown-item mt-2" data-toggle="dropdown" onClick={() => rowbuttonAction('History', dataItem)}>
                                          Fim de Vindima
<i className="fa fa-history float-right" aria-hidden="true" />
                                        </span>
                                        <ul className="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu">
                                          <li className="dropdown-submenu">
                                            <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('Definir', dataItem)}>
              Definir<i className="fas fa-print float-right" />
            </span>
                                          </li>
                                          <li className="dropdown-submenu">
                                            <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('Remover', dataItem)}>
              Remover<i className="fas fa-print float-right" />
            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('Remover Entidade/NIV', dataItem)}>
                                      Remover Entidade/NIV
                                      <i className="fas fa-print float-right" />
                                    </span>
                                    <span className="dropdown-item mt-2" onClick={() => rowbuttonAction('Exportar p/ XML (Ultimo REU)', dataItem)}>
                                      Exportar p/ XML (Ultimo REU)
                                      <i className="fas fa-water float-right" />
                                    </span>
                                    <span className="dropdown-item mt-2" data-toggle="modal" data-target="#vindima-modal" onClick={() => rowbuttonAction('Imprimir', dataItem)}>
                                      Imprimir
                                      <i className="fas fa-water float-right" />
                                    </span>
                                  </div>
                                </Tooltip>
                                )
                            }
              {
                                actionbuttons.Delete
                                && <DeleteModal handleDelete={(id) => deleteFunc(id)} row={dataItem} className=" ml-3" />
                            }

                              {
                                  actionbuttons.AdministrationDelete && (
                                    <ConfirmationModal handleConfirmation={(data)=>deleteFunc(data)} row={dataItem} useFor={actionbuttons.AdministrationDelete} />
                                  )
                                }
            </div>
          </td>
        );
      }
      return (
        <td />
      );
    }
  };
}
